export default "__VITE_ASSET__i$iOC5ib__"